import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import { TExploreProductType } from 'interfaces/explore';

type CategoryPickerProps = {
  handleCategoryChange: (
    arg:
      | Extract<TExploreProductType, 'nfts' | 'collections'>
      | 'artists'
      | 'all'
  ) => void;
};

export const CategoryPicker = ({
  handleCategoryChange
}: CategoryPickerProps) => {
  const { t } = useTranslation();

  return (
    <Select
      defaultValue="all"
      onChange={handleCategoryChange}
      options={[
        {
          value: 'all',
          label: t('generic.all')
        },
        {
          value: 'nfts',
          label: t('generic.nfts')
        },
        {
          value: 'collections',
          label: t('collection.collections')
        },
        {
          value: 'artists',
          label: t('artist.creators')
        }
      ]}
    />
  );
};
